<template>
    <div class="editor">
        <div class="top-nav">
            <div class="top-left">
                <div class="logo"></div>
                <div class="title">在线编辑器</div>
                <div class="label">内测版</div>
            </div>
            <div class="top-right">
                <div class="document">
                    <div class="icon"></div>
                    <div class="text" @click="goto('document')">查看文档</div>
                </div>
                <div class="download" @click="goto('download')">
                    <div class="icon"></div>
                    <div class="text">下载 Demo</div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="aside-bar">
                <div router class="menu" :default-active="defaultActiveFormat($route.path)">
                    <div v-for="(item,key) in appBuilderLeftNav" :key="key" class="menu-item" :class="{'is-active': $route.path}" :index="indexFormat(item.path)">
                        <div :class="iconMap[item.path]" class="menu-icon"></div>
                    </div>
                </div>
            </div>
            <div class="content-box">
                 <div class="module">
                    <div class="module-item">
                        <div class="desc"><span>1</span>请选择场景</div>
                        <div class="item"
                            :class="{'is-active': classType === item.value}"
                            v-for="item in classTypeOptions"
                            :key="item.vaule"
                            @click="classChoose(item)"
                        >
                            {{item.label}}
                        </div>
                    </div>
                    <div class="module-item">
                        <div class="desc"><span>2</span>请选择配置模块</div>
                        <div class="item"
                            :class="{'is-active': configModule === item.value}"
                            v-for="item in options"
                            :key="item.vaule"
                            @click="muduleChoose(item)"
                        >
                            {{item.label}}
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <el-button class="button" :disabled="false" @click="update">更新配置到App</el-button>
                </div>
                <general-config v-show="configModule === 1" :config="config"></general-config>
                <navigation-bar v-show="configModule === 2" :config="config"></navigation-bar>
                <video-mode v-show="configModule === 3" :config="config"></video-mode>
                <share-mode v-show="configModule === 4" :config="config"></share-mode>

            </div>
        </div>
        <div class="dialog" v-if="isFormShow">
          <div class="close-icon" @click="closeDialog"></div>
          <div class="title">体验完整功能</div>
          <div class="desc">RoomKit 在线编辑器更多能力正在火热内测中，请留下<br/>您的联系方式，我们将为您演示更完整的功能</div>
          <el-form :model="form" ref="form" class="form-box" :rules="rules" hide-required-asterisk>
            <el-form-item prop="name" label="姓名" class="form-item">
              <el-input placeholder="请输入您的姓名" v-model.trim="form.name" maxlength="20" onKeypress="if (event.keyCode == 32 || event.which == 32) return false"></el-input>
            </el-form-item>
            <el-form-item prop="phone" label="手机" class="form-item">
              <el-input type="number" placeholder="请输入您的手机" v-model.trim="form.phone" onKeypress="if (event.keyCode == 32 || event.which == 32) return false"></el-input>
            </el-form-item>
            <el-form-item prop="email" label="邮箱" class="form-item">
              <el-input placeholder="请输入您的邮箱" v-model.trim="form.email" onKeypress="if (event.keyCode == 32 || event.which == 32) return false"></el-input>
            </el-form-item>
            <el-form-item prop="company" label="公司" class="form-item">
              <el-input placeholder="请输入您的公司名称" v-model.trim="form.company" maxlength="50" onKeypress="if (event.keyCode == 32 || event.which == 32) return false"></el-input>
            </el-form-item>
            <el-form-item class="form-button">
                <el-button :disabled="isSumbitDisabled" class="button" type="primary" @click="submit">提 交</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="mask" v-if="isFormShow"></div>
    </div>
</template>
<script>
import GeneralConfig from './general-config'
import NavigationBar from './navigation-bar'
import VideoMode from './video-mode'
import ShareMode from './share-mode'
import langPhoneConfig from '../assets/json/large-phone.json'
import singlePhoneConfig from '../assets/json/1v1-phone.json'
import smallPhoneConfig from '../assets/json/small-phone.json'
export default {
  data () {
    const validatePhone = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入手机号'))
      } else if (value.length < 11) {
        callback(new Error('请输入正确的手机号'))
        this.phoneValid = false
      } else {
        this.phoneValid = true
        callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        callback(new Error('请输入邮箱'))
      } else {
        let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的邮箱地址'))
          this.emailValid = false
        } else {
          this.emailValid = true
        }
        callback()
      }
    }
    return {
      appBuilderLeftNav: [
        {
          'name': '功能配置',
          'path': '/'
        }
      ],
      iconMap: {},
      configModule: 1,
      options: [
        {
          value: 1,
          label: '通用配置'
        },
        {
          value: 2,
          label: '导航栏配置'
        },
        {
          value: 3,
          label: '视频模式配置'
        },
        {
          value: 4,
          label: '共享模式配置'
        }
      ],
      classType: 1,
      classTypeOptions: [
        {
          value: 1,
          label: '小班课'
        },
        {
          value: 2,
          label: '大班课'
        },
        {
          value: 3,
          label: '视频会议'
        }
      ],
      isFormShow: false,
      form: {
        name: '',
        phone: '',
        email: '',
        company: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'change' }
        ],
        email: [
          { validator: validateEmail, trigger: 'change' }
        ],
        company: [
          { required: true, message: '请输入公司', trigger: 'change' }
        ]
      },
      phoneValid: false,
      emailValid: false
    }
  },
  created () {
    this.iconMap = {
      '/': 'icon-function'
    }
    const map = new Map([
      ['2', langPhoneConfig],
      ['3', singlePhoneConfig],
      ['1', smallPhoneConfig]
    ])
    const defaultConfig = map.get(`${this.classType}`)
    this.config = JSON.parse(JSON.stringify(defaultConfig))
    window.addEventListener('resize', this.resize)
  },
  mounted () {
    this.resize()
  },
  computed: {
    isSumbitDisabled () {
      return !(this.form.name && (this.form.phone && this.phoneValid) && (this.form.email && this.emailValid) && this.form.company)
    }
  },
  methods: {
    submit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const sendData = {
            name: this.form.name,
            tel: this.form.phone,
            email: this.form.email,
            company: this.form.company
          }
          this.$axios({
            method: 'post',
            url: 'https://edusuite-feedback-general.zego.im/activity/collect_user_info',
            data: sendData
          }).then((res) => { // 这里使用了ES6的语法
            if (res.data.code === 0) {
              this.isFormShow = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
            } else if (res.data.code === 100000) {
              this.$message({
                message: '填写的内容有误，请确认后重新提交',
                type: 'error'
              })
            } else {
              this.$message({
                message: '提交失败，请稍后再试',
                type: 'error'
              })
            }
          }).catch((error) => {
            console.log(error) // 请求失败返回的数据
            this.$message({
              message: '提交失败，请稍后再试',
              type: 'error'
            })
          })
        } else {
          console.log('error submit!!')
          this.$message({
            message: '提交失败，请稍后再试',
            type: 'error'
          })
          return false
        }
      })
    },
    closeDialog () {
      this.isFormShow = false
    },
    resize () {
      const viewBox = Array.from(document.getElementsByClassName('view-box'))
      viewBox.forEach(item => {
        item.style.width = `${window.document.documentElement.clientWidth - 272 - 81 - 160}px`
      })
    },
    indexFormat (path) {
      return path
    },
    defaultActiveFormat (path) {
      return path
    },
    classChoose (data) {
      if (this.classType !== data.value) {
        this.classType = data.value
        this.configModule = 1
        const map = new Map([
          ['2', langPhoneConfig],
          ['3', singlePhoneConfig],
          ['1', smallPhoneConfig]
        ])
        const defaultConfig = map.get(`${this.classType}`)
        this.config = JSON.parse(JSON.stringify(defaultConfig))
      }
    },
    muduleChoose (data) {
      this.configModule = data.value
    },
    update () {
      this.form = {
        name: '',
        phone: '',
        email: '',
        company: ''
      }
      this.isFormShow = true
    },
    goto (type) {
      switch (type) {
        case 'document':
          window.location.href = 'https://doc-zh.zego.im/article/7816'
          break
        case 'download':
          window.location.href = 'https://doc-zh.zego.im/scene-plan/23'
          break
      }
    }
  },
  components: {
    GeneralConfig,
    NavigationBar,
    VideoMode,
    ShareMode
  }
}
</script>
<style lang="less" scoped>
.editor {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    .top-nav {
        z-index: 100;
        position: fixed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        width: 100%;
        height: 64px;
        .top-left {
            display: flex;
            align-items: center;
            .logo {
                margin-left: 32px;
                width: 115px;
                height: 40px;
                background-image: url('../assets/img/appbuilder-logo.png');
                background-size: cover;
            }
            .title {
                margin: 0 6px 0 4px;
                font-size: 16px;
                font-weight: 600;
            }
            .label {
                padding: 10px 6px;
                font-size: 22px;
                background-color: #B6BCC7;
                border-radius: 4px;
                color: #fff;
                zoom: 0.5;
            }
        }
        .top-right {
            display: flex;
            align-items: center;
            .document {
                cursor: pointer;
                display: flex;
                align-items: center;
                margin-right: 36px;
                padding: 8px 12px;
                .icon {
                    margin-right: 6px;
                    width: 20px;
                    height: 20px;
                    background-image: url('../assets/img/nav-view-icon.png');
                    background-size: cover;
                }
                .text {
                    font-size: 14px;
                    color: #33383E;
                    font-weight: 400;
                }
                &:hover {
                  border-radius: 4px;
                  background-color: #f6f7f9;
                }
            }
            .download {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 24px;
                width: 132px;
                height: 36px;
                border: 1px solid #2563EB;
                border-radius: 4px;
                .icon {
                    margin-right: 5px;
                    width: 20px;
                    height: 20px;
                    background-image: url('../assets/img/nav-download-icon.png');
                    background-size: cover;
                }
                .text {
                    font-size: 14px;
                    color: #2563EB;
                    font-weight: 400;
                }
                &:hover {
                  border: 1px solid #1b4cca;
                  .icon {
                    background-image: url('../assets/img/nav-download-icon-hover.png');
                  }
                  .text {
                    color: #1b4cca;
                  }
                }
            }
        }
    }
    .container {
        flex-grow: 1;
        display: flex;
        margin-top: 66px;
        background-color: #f5f6f8;
        .aside-bar {
            position: fixed;
            top: 66px;
            left: 0;
            padding-top: 24px;
            width: 80px;
            height: 100%;
            background-color: #fff;
            .menu {
                width: 100%;
                border-right: 0;
                .menu-item {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 16px 0;
                    width: 100%;
                    height: 32px;
                    line-height: 32px;
                    color: #9DA3AC;
                    border-left: 6px solid #fff;
                    &.is-active {
                        color: #00254D;
                        background-color: #fff;
                        border-color: #00254D;
                        box-shadow: none;
                        .menu-icon {
                            &.icon-function {
                                background-image: url('../assets/img/config-icon-active.png');
                            }
                        }
                    }
                    .menu-icon {
                        margin-right: 6px;
                        width: 24px;
                        height: 24px;
                        background-size: cover;
                        &.icon-function {
                            background-image: url('../assets/img/config-icon.png');
                        }
                    }
                    &:hover {
                        background-color: transparent;
                    }
                }
            }
        }
        .content-box {
            flex-grow: 1;
            margin-left: 81px;
            position: relative;
            display: flex;
            min-height: 100%;
            .module {
                z-index: 6;
                position: fixed;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 8px;
                width: 160px;
                height: 100%;
                background-color: #fff;
                font-size: 12px;
                overflow: scroll;
                .module-item {
                    margin-top: 14px;
                    padding: 0 10px;
                    width: 100%;
                    .desc {
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;
                        padding-left: 2px;
                        width: 140px;
                        height: 36px;
                        color: #9DA3AC;
                        span {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin-right: 6px;
                            width: 30px;
                            height: 30px;
                            font-size: 20px;
                            background-color: #B6BCC7;
                            border-radius: 50%;
                            color: #fff;
                            zoom: 0.5;
                        }
                    }
                    .item {
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        margin-bottom: 6px;
                        padding-left: 14px;
                        width: 140px;
                        height: 36px;
                        cursor: pointer;
                        color: #33383E;
                        &:hover, &.is-active{
                            background-color: #F6F7F9;
                            border-radius: 4px;
                        }
                    }
                }

            }
            .btn-box {
                position: absolute;
                top: 22px;
                right: 302px;
                .button {
                    padding: 0 20px;
                    height: 36px;
                    background-color: #2563EB;
                    color: #fff;
                    border: none;
                    font-weight: 400;
                    &:hover{
                        background-color: #1B4CCA;
                        border-color: #1B4CCA;
                    }
                }

            }
        }
    }
    .dialog {
        z-index: 102;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 520px;
        height: 656px;
        background-color: #fff;
        border-radius: 8px;
        .close-icon {
            cursor: pointer;
            align-self: flex-end;
            margin: 16px 16px 0 0;
            width: 20px;
            height: 20px;
            background-image: url('../assets/img/close-icon.png');
            background-size: cover;
        }
        .title {
            margin: 14px 0;
            font-size: 26px;
            color: #2563EB;
            font-weight: 500;
        }
        .desc {
            margin-bottom: 38px;
            font-size: 16px;
            line-height: 24px;
            color: #636C78;
            font-weight: 400;
            text-align: center;
        }
        .form-box {
            display: flex;
            flex-direction: column;
            width: 380px;
            .form-item {
                margin-bottom: 26px;
            }
            .form-button {
                margin-top: 6px;
                margin-bottom: 0;
            }
        }
    }
    .mask {
        position: fixed;
        z-index: 101;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.4);
    }
}
</style>
<style scoped>
.form-box.el-form >>> .el-form-item__label {
    padding-left: 3px;
    line-height: 14px;
    margin-bottom: 12px;
    font-size: 14px;
    color: #33383E;
    font-weight: 500;
}
.form-box.el-form >>> .el-button.el-button--primary {
    width: 380px;
    height: 44px;
    background: linear-gradient(26deg, #5FB2FF 0%, #2563EB 100%);
    border: none;
}
.form-box.el-form >>> .el-button.is-disabled {
    padding: 0;
    opacity: 0.5;
    background: linear-gradient(26deg, #5FB2FF 0%, #2563EB 100%);
}

</style>



// WEBPACK FOOTER //
// src/views/index.vue